import { useAppQuery } from "~/hooks/useAppQuery"
import { getNotifications } from "../server/notifications.functions"

export const notificationsQueryKey = ["notifications"] as const

export function useNotifications() {
  return useAppQuery({
    queryKey: notificationsQueryKey,
    queryFn: () =>
      getNotifications({
        data: {},
      }),
    errorMessage: "Не удалось загрузить уведомления",
  })
}
